import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BranchAvatarModule } from '@portal-core/branches/components/branch-avatar/branch-avatar.module';
import { ErrorsExpansionPanelModule } from '@portal-core/general/components/errors-expansion-panel/errors-expansion-panel.module';
import { LoaderModule } from '@portal-core/general/components/loader/loader.module';
import { NoItemPlaceholderModule } from '@portal-core/general/components/no-item-placeholder/no-item-placeholder.module';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUserAsyncModule } from '@portal-core/license-users/pipes/license-user-async/license-user-async.module';
import { ProfileTabModule } from '@portal-core/profiles/directives/profile-tab/profile-tab.module';
import { ProjectChecklistAvatarModule } from '@portal-core/project-checklists/components/project-checklist-avatar/project-checklist-avatar.module';
import { ProjectChecklistColumnsFormModule } from '@portal-core/project-checklists/components/project-checklist-columns-form/project-checklist-columns-form.module';
import { ProjectChecklistDeletionFormModule } from '@portal-core/project-checklists/components/project-checklist-deletion-form/project-checklist-deletion-form.module';
import { ProjectChecklistNotificationListModule } from '@portal-core/project-checklists/components/project-checklist-notification-list/project-checklist-notification-list.module';
import { ProjectChecklistOverviewModule } from '@portal-core/project-checklists/components/project-checklist-overview/project-checklist-overview.module';
import { ProjectChecklistRowsFormModule } from '@portal-core/project-checklists/components/project-checklist-rows-form/project-checklist-rows-form.module';
import { ProjectChecklistSettingsFormModule } from '@portal-core/project-checklists/components/project-checklist-settings-form/project-checklist-settings-form.module';
import { ProjectChecklistAsyncModule } from '@portal-core/project-checklists/pipes/project-checklist-async/project-checklist-async.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { SwitchBoardModule } from '@portal-core/ui/switch-board/switch-board.module';
import { ProjectChecklistProfileComponent } from './project-checklist-profile.component';

@NgModule({
  declarations: [ProjectChecklistProfileComponent],
  exports: [ProjectChecklistProfileComponent],
  imports: [
    BranchAvatarModule,
    CommonModule,
    ErrorsExpansionPanelModule,
    LicenseUserAvatarModule,
    LicenseUserAsyncModule,
    LoaderModule,
    MatIconModule,
    MatListModule,
    MatTabsModule,
    MatTooltipModule,
    NoItemPlaceholderModule,
    SwitchBoardModule,
    ProjectAvatarModule,
    ProjectChecklistAvatarModule,
    ProjectChecklistDeletionFormModule,
    ProjectChecklistAsyncModule,
    ProjectChecklistSettingsFormModule,
    ProjectChecklistColumnsFormModule,
    ProjectChecklistRowsFormModule,
    ProjectChecklistNotificationListModule,
    ProjectChecklistOverviewModule,
    ProfileTabModule
  ]
})
export class ProjectChecklistProfileModule { }
